import { EquatorialCoord, deg2rad, rad2deg } from '@hscmap/angle';
import { Bridge } from "..";

interface IJumpTo {
  type: 'jump_to'
  args: {
    ra: number
    dec: number
    fov: number,
  }
}

export function jump_to(b: Bridge, msg: IJumpTo) {
  const { ra, dec, fov } = msg.args
  const fovRad = deg2rad(fov)
  b.globe.viewFactory.jumpTo({ fovy: fovRad }, { coord: EquatorialCoord.fromDeg(ra, dec) })
}
